import { Layer, Source } from "react-map-gl/mapbox"

interface RadonLayerProps {
  opacity?: number
}

export const RadonLayer = ({ opacity = 0.7 }: RadonLayerProps) => {
  return (
    <Source
      id="raster-radon"
      type="raster"
      tiles={[
        "https://mapsref.brgm.fr/wxs/georisques/risques?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=RADON_COMMUNE&STYLES=&SRS=EPSG%3A3857&CRS=EPSG%3A3857&TILED=true&WIDTH=256&HEIGHT=256&BBOX={bbox-epsg-3857}",
      ]}
      tileSize={256}
      maxzoom={15}
    >
      <Layer id="raster-radon" type="raster" source="raster-radon" paint={{ "raster-opacity": opacity }} />
    </Source>
  )
}
